export const PERMISSIONS_UPDATE_COLOR_PALETTE_ERROR =
  'PERMISSIONS_UPDATE_COLOR_PALETTE_ERROR';
export const PERMISSIONS_UPDATE_COLOR_PALETTE_START =
  'PERMISSIONS_UPDATE_COLOR_PALETTE_START';
export const PERMISSIONS_UPDATE_COLOR_PALETTE_SUCCESS =
  'PERMISSIONS_UPDATE_COLOR_PALETTE_SUCCESS';
